<h2 mat-dialog-title>Pending Access Requests</h2>
<div>
<p>Save your work to finish the granted process.</p>
<p>Granted users will be added to the "users" section in the form.</p>
</div>
<mat-dialog-content>
  <h3>Select users to grant or deny access:</h3>
  <ul class="pending-users-list" role="list">
    <li class="pending-users-row header" aria-hidden="true">
      <span></span>
      <span class="pending-users-action">Approve</span>
      <span class="pending-users-action">Deny</span>
    </li>
    @for (user of dialogData.pendingUsers; track getUserId(user)) {
      <li class="pending-users-row">
        <span>{{ getUserName(user) }}</span>
        <mat-checkbox
          class="pending-users-action"
          [checked]="getDecision(getUserId(user)) === 'approve'"
          [disabled]="getDecision(getUserId(user)) === 'deny'"
          (change)="onDecisionChange(getUserId(user), 'approve', $event.checked)"
          [attr.aria-label]="'Approve ' + getUserName(user)">
        </mat-checkbox>
        <mat-checkbox
          class="pending-users-action"
          [checked]="getDecision(getUserId(user)) === 'deny'"
          [disabled]="getDecision(getUserId(user)) === 'approve'"
          (change)="onDecisionChange(getUserId(user), 'deny', $event.checked)"
          [attr.aria-label]="'Deny ' + getUserName(user)">
        </mat-checkbox>
      </li>
    }
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="confirm()">Submit</button>
</mat-dialog-actions>
